import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

interface ThemeToggleProps {
  className?: string;
}

/**
 * Compact light/dark switch for the app shell. Uses an accessible button with a
 * live label and a subtle crossfade between the sun and moon glyphs.
 */
const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`relative grid h-9 w-9 place-items-center rounded-full border border-dark-border text-text-muted transition-all duration-300 ease-premium hover:text-text-primary hover:border-accent-blue hover:bg-dark-bg ${className}`}
    >
      <Sun
        className={`absolute h-5 w-5 transition-all duration-300 ease-premium ${
          isDark ? 'scale-50 opacity-0 rotate-90' : 'scale-100 opacity-100 rotate-0'
        }`}
      />
      <Moon
        className={`absolute h-5 w-5 transition-all duration-300 ease-premium ${
          isDark ? 'scale-100 opacity-100 rotate-0' : 'scale-50 opacity-0 -rotate-90'
        }`}
      />
    </button>
  );
};

export default ThemeToggle;
